import React from 'react';
import { Field } from 'redux-form';
import Grid from '../layout/grid';

const RenderInput = ({
	input,
	placeholder,
	readOnly,
	type = 'text'
}) => (
	<input
		{...input}
		type={type}
		className="form-control"
		placeholder={placeholder}
		readOnly={readOnly}
	/>
);

const TextArrayField = ({
	fields,
	label,
	placeholder,
	readOnly,
	type = 'text',
    cols
}) => (
	<Grid cols={cols}>

		{label &&
			<label>{label}</label>
		}

		{fields.map((campo, index) => (
			<div
				key={campo}
				style={{
					display: 'flex',
					alignItems: 'center',
					marginBottom: 8
				}}
			>
				<div style={{ flex: 1, minWidth: 0 }}>
					<Field
						name={campo}
						component={RenderInput}
						type={type}
						placeholder={`${placeholder || 'Informe o valor'} ${index + 1}`}
						readOnly={readOnly}
					/>
				</div>

				{!readOnly &&
					<button
						type="button"
						className="btn btn-danger btn-sm"
						style={{
							marginLeft: 8,
							width: 34,
							height: 34
						}}
						title="Remover"
						onClick={() => fields.remove(index)}
					>
						<i className="fa fa-trash" />
					</button>
				}
			</div>
		))}

		{!readOnly &&
			<button
				type="button"
				className="btn btn-primary btn-sm"
				onClick={() => fields.push('')}
			>
				<i className="fa fa-plus" /> Adicionar e-mail
			</button>
		}

	</Grid>
);

export default TextArrayField;